import { render, staticRenderFns } from "./select-currency-global.vue?vue&type=template&id=744b54fc"
import script from "./select-currency-global.vue?vue&type=script&lang=js"
export * from "./select-currency-global.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports